module.exports = __webpack_public_path__ + "static/media/background-join.55d598c6.svg";